module.exports = __webpack_public_path__ + "static/media/tap-to-solve@2x.88f8a031.png";